export interface RequestData {
    time: string;
    official: boolean
}

export interface ResponseData {
    success: boolean;
    message: string;
}

export async function putData(url: string, data: RequestData): Promise<void> {
    if(data===undefined || data === null) {
        console.log("EMPTY!")
        return;
    }
    fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    });
    //const responseData: ResponseData = await response.json();
    //return responseData;
}

